import { SvgIcon } from "@mui/material"

import { ReactComponent as AuditIcon } from "./audit.svg"

export const StatusAuditIcon = (props) => {
    return (
        <SvgIcon component={AuditIcon} {...props} inheritViewBox />
    )
}